import { render, staticRenderFns } from "./pageTermsAndConditions.vue?vue&type=template&id=788fcd96&"
import script from "./pageTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./pageTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./pageTermsAndConditions.vue?vue&type=style&index=0&id=788fcd96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports